import { GetStaticPaths } from 'next';
import { getLayout } from 'components/layouts/Header';
import CommunityPage, {
  getStaticProps,
} from 'pages/societies/[slug]/index.page';
import { API_ROUTES } from 'lib/api-routes';
import { StudentSocietiesResponse } from 'lib/models/student-society';
import { pageBuilderInstance } from 'lib/utils/axios';
import { parseArrayResponse } from 'lib/utils/parser';

export const getStaticPaths: GetStaticPaths = async () => {
  if (process.env.SKIP_BUILD_STATIC_GENERATION) {
    return {
      paths: [],
      fallback: 'blocking',
    };
  }
  const { data } = await pageBuilderInstance<StudentSocietiesResponse>(
    `${API_ROUTES.STUDENT_SOCIETIES}/basic_index?per_page=100000`
  );
  const societies = parseArrayResponse(data);
  const paths = societies
    .filter(({ short_slug }) => !!short_slug)
    .map(({ short_slug }) => {
      return {
        params: { slug: short_slug },
      };
    });
  return { paths, fallback: 'blocking' };
};

export { getStaticProps };

// @ts-ignore
CommunityPage.getLayout = getLayout;

export default CommunityPage;
